<template>
  <div class="filter-widget">
    <h2 class="widget-title">{{filter.label}}</h2>
    <div class="widget-listing">
      <ul class="size">
        <li v-for="(option, option_key) in filter.options" :key="option_key">
          <input
            type="radio"
            @change="set_attribute(option)"
            :name="filter.name"
            v-model="option.selected"
            :value="true"
            :id="'check'+option.id"
          />
          <label
            :for="'check'+option.id"
            :style="{backgroundColor: option.key, border: '1px solid ' + option.key}"
          >{{option.key}}</label>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  props: ['filter'],
  data () {
    return {
      selected_options: []
    }
  },
  methods: {
    set_attribute (option) {
      this.$emit('set_attribute', option, this.filter.name)
    }
  }
}
</script>
